// eslint-disable-next-line
export const EmailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line
export const PasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/;
export const WebStorageNames = {
  UserInfo: "userInfo",
  AuthInfo: "authInfo",
  UserLoggedIn: "userLoggedIn",
  IsFirstLogin: "isFirstLogin",
  RoleId: "roleId",
  SelectedCompany: "selectedCompany",
  IsAnnualLeavePopupShown: "isAnnualLeavePopupShown",
  SelfUserId: "selfUserId",
  /** Super Admin jumped into a tenant — send X-Company-Id and show full admin sidebar */
  SuperAdminInCompany: "superAdminInCompany",
};

export const Colors = {
  Red: "#E60000",
  Pink: "#E296AC",
  Orange: "#FEC64D",
  Yellow: "#FFF159",
  Green: "#4CBB17",
  Black: "#111",
};

/**
 * Accrual Start Type Options
 * These options define when leave accrual begins for employees.
 * 
 * - EmploymentStart: Accrual starts from the employee's hire/start date
 * - LeaveYearStart: Accrual starts from the leave year start date configured for each user
 * - CalendarYear: Accrual starts from January 1st of each calendar year (standard calendar: Jan 1 - Dec 31)
 * - Tiered: Accrual is based on tenure tiers (for tiered leave types)
 */
export const ACCRUAL_START_DATE_OPTIONS = [
  { value: 'LeaveYearStart', label: 'Leave Year Start' },
  { value: 'EmploymentStart', label: 'Employee Hire Date' },
  { value: 'CalendarYear', label: 'Calendar Year Start' },
];

// For backward compatibility and easier access
export const ACCRUAL_START_DATE_VALUES = {
  LEAVE_YEAR_START: 'LeaveYearStart',
  EMPLOYMENT_START: 'EmploymentStart',
  CALENDAR_YEAR: 'CalendarYear',
  // Legacy support for old "HireDate" value
  HIRE_DATE: 'EmploymentStart',
};

/**
 * Accrual Frequency Options
 * These options define how often leave is accrued for employees.
 * 
 * - Annually: Front-loaded (Annual Grant) - Full year's leave granted at once
 * - Monthly: Leave accrues every month
 * - BiWeekly: Leave accrues every two weeks
 * - Weekly: Leave accrues every week
 * - Quarterly: Leave accrues every quarter (3 months)
 */
export const ACCRUAL_FREQUENCY_OPTIONS = [
  { value: 'Annually', label: 'Front-loaded (Annual Grant)' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'BiWeekly', label: 'Bi-weekly' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Quarterly', label: 'Quarterly' },
];